<template>
  <v-autocomplete
  v-model="selection"
  :label="$t('rateSheetDefinition')"
  :items="rateSheetDefinitions"
  :disabled="isDisabled"
  :clearable="clearable"
  item-text="name"
  item-value="name"
  return-object
  id="rate-sheet-definition-autocomplete"
  @change="defnChosen">
    <template #item="{ item: rateSheetDefinition }">
      <v-list-item-content>
        <v-list-item-title>
          <v-row>
            <v-col cols="auto">
              <v-icon>
                {{ getCheckboxIcon(rateSheetDefinition) }}
              </v-icon>
            </v-col>

            <v-col>
              <span>{{ rateSheetDefinition.name }}</span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RateSheetDefinitionAutocomplete',

  props: {
    propRateSheetDefinitions: {
      type: Array,
      required: true
    },
    propSelection: {
      type: Object,
      required: false,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    clearable: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: () => ({
    selection: null
  }),

  watch: {
    propSelection (sel) {
      if (this?.selection?.rateSheetDefinitionId !== sel?.rateSheetDefinitionId) {
        this.selection = sel
      }
    }
  },

  created () {
    if (this.propSelection) {
      this.selection = this.propSelection
    } else {
      if (this.rateSheetDefinitions.length > 1) {
        this.selection = null
      } else {
        this.selection = this.rateSheetDefinitions[0]
        this.$emit('chosen-automatic', this.selection)
      }
    }
  },

  computed: {
    ...mapGetters('rate-sheet-definition', ['accountRateSheetDefinitions']),

    rateSheetDefinitions () {
      return this.propRateSheetDefinitions ?? this.accountRateSheetDefinitions
    },

    isDisabled () {
      return this.disabled || !(this.rateSheetDefinitions?.length > 1)
    }
  },

  methods: {
    defnChosen (value) {
      this.$emit('chosen', value)
    },

    getCheckboxIcon (item) {
      if (this.multiple) {
        return this.selection.some(i => i.rateSheetDefinitionId === item.rateSheetDefinitionId) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      } else {
        return item === this.selection ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
      }
    }
  }
}
</script>
